import React, { Component } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import Form from '../components/Form/contactForm';

class ContactUs extends Component {
  render() {
    return (
      <>
        <Head>
          <meta
            name="keywords"
            content="Hidream讯梦国际联系方式电话地址，易赛诺联系方式电话地址"
          />
          <meta
            name="description"
            content="Hidream讯梦国际总部在浙江杭州，如需市场合作、商务合作，可随时联系我们。"
          />
        </Head>

        <div id="contactus" className="contactus">
          <div className="banner">
            <Image
              src={require('../public/images/banner-6.png').default}
              alt="联系我们"
              layout="responsive"
            />
          </div>

          <div className="bb m-auto">
            <div className="flex justify-between py-10">
              <div className="contact_info text-left">
                <div className="header">
                  <div className="section_header_2">
                    <h3>
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-hidreamzhutituan"></use>
                      </svg>
                      <span>联系我们</span>
                    </h3>
                    <p>留下你的联系方式，将由我们专业的营销顾问为你服务</p>
                  </div>
                </div>

                <div className="contact-information">
                  <div className="item">
                    <div className="title">
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-hidreamjiaru1"></use>
                      </svg>
                      <span className="name">加入我们</span>
                    </div>
                    <p className="mail">E-mail：zhouyujie@hidream.net</p>
                  </div>

                  <div className="item">
                    <div className="title">
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-hidreamshichang1"></use>
                      </svg>
                      <span className="name">市场合作</span>
                    </div>
                    <p className="mail">E-mail：wangrui@hidream.net</p>
                  </div>

                  <div className="item">
                    <div className="title">
                      <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-hidreamshangwu1"></use>
                      </svg>
                      <span className="name">商务合作</span>
                    </div>
                    <p className="mail">E-mail：yeguanghui@hidream.net</p>
                  </div>
                </div>

                <div className="bottom-image">
                  <Image
                    src={require('../public/images/信件插画.png').default}
                    alt="信件插画"
                  />
                </div>
              </div>

              <div className="contact_form px-12 py-10 xl:px-16">
                <Form />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ContactUs;
